import script from "./FormShare.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormShare.vue?vue&type=script&lang=ts&setup=true"

import "./FormShare.vue?vue&type=style&index=0&id=9b3b8300&lang=scss"

const __exports__ = script;

export default __exports__